import { useState } from "react";
import { Button } from "@/components/ui/button";
import { LogOut, Monitor, ArrowLeft, Database, LayoutTemplate, Wand2, User } from "lucide-react";
import ProfileDialog from "@/components/ProfileDialog";
import DatasetsTab from "@/components/idc/DatasetsTab";
import TemplatesTab from "@/components/idc/TemplatesTab";
import GenerateTab from "@/components/idc/GenerateTab";

const TABS = [
  { id: "data", label: "Data", icon: Database },
  { id: "templates", label: "Templates", icon: LayoutTemplate },
  { id: "generate", label: "Generate", icon: Wand2 },
];

export default function IDCApp({ shop, onLogout, onInstall, onBack, onShopUpdate }) {
  const [tab, setTab] = useState("data");
  const [showProfile, setShowProfile] = useState(false);

  return (
    <div className="min-h-screen bg-background" data-testid="idc-app">
      <header className="sticky top-0 z-20 bg-white border-b border-border">
        <div className="h-1 flex">
          <div className="flex-1 bg-cyan-500" />
          <div className="flex-1 bg-pink-600" />
          <div className="flex-1 bg-yellow-400" />
          <div className="flex-1 bg-slate-900" />
        </div>
        <div className="max-w-6xl mx-auto px-4 sm:px-6 py-3 flex flex-wrap items-center gap-2 sm:gap-3">
          <Button size="sm" variant="ghost" onClick={onBack} data-testid="idc-back-btn" className="gap-1 text-muted-foreground hover:text-foreground -ml-2">
            <ArrowLeft className="h-4 w-4" />
            <span className="hidden sm:inline">Features</span>
          </Button>
          <img src="/logo.webp?v=2" alt="Sootrik" className="h-8 sm:h-9 w-auto" data-testid="header-logo" />
          <div className="w-full sm:w-auto sm:flex-1 sm:min-w-0 order-2 sm:order-none">
            <p className="font-heading font-bold text-sm sm:text-base truncate">ID / Certificate Creator</p>
            <p className="text-xs text-muted-foreground truncate" data-testid="header-shop-name">{shop.name}</p>
          </div>
          <div className="flex items-center gap-1 sm:gap-1.5 shrink-0 ml-auto">
          <Button size="sm" variant="outline" onClick={onInstall} data-testid="pwa-install-btn" className="gap-1.5 border-cyan-500 text-cyan-700 hover:bg-cyan-50">
            <Monitor className="h-4 w-4" />
            <span className="hidden sm:inline">Install</span>
          </Button>
          <Button size="sm" variant="ghost" onClick={() => setShowProfile(true)} data-testid="profile-btn" className="gap-1.5 text-muted-foreground hover:text-foreground">
            <User className="h-4 w-4" />
            <span className="hidden sm:inline">Profile</span>
          </Button>
          <Button size="sm" variant="ghost" onClick={onLogout} data-testid="logout-btn" className="gap-1.5 text-muted-foreground hover:text-foreground">
            <LogOut className="h-4 w-4" />
            <span className="hidden sm:inline">Logout</span>
          </Button>
          </div>
        </div>
      </header>

      <main className="max-w-6xl mx-auto px-4 sm:px-6 py-6 space-y-6">
        <nav className="flex gap-2 border-b border-border" data-testid="idc-tabs">
          {TABS.map((t) => (
            <button
              key={t.id}
              data-testid={`idc-tab-${t.id}`}
              onClick={() => setTab(t.id)}
              className={`flex items-center gap-1.5 px-4 py-2.5 text-sm font-semibold rounded-t-lg border-b-2 transition-colors ${
                tab === t.id
                  ? "border-cyan-600 text-cyan-700 bg-cyan-50/60"
                  : "border-transparent text-muted-foreground hover:text-foreground hover:bg-slate-50"
              }`}
            >
              <t.icon className="h-4 w-4" /> {t.label}
            </button>
          ))}
        </nav>

        {tab === "data" && <DatasetsTab />}
        {tab === "templates" && <TemplatesTab />}
        {tab === "generate" && <GenerateTab />}
      </main>

      <ProfileDialog
        open={showProfile}
        onClose={() => setShowProfile(false)}
        shop={shop}
        onUpdated={onShopUpdate}
      />
    </div>
  );
}
